<script setup>
import { CubeIcon, CogIcon } from "@heroicons/vue/24/outline";
import ActionButton from "@js/components/ActionButton.vue";
import DisplayContentAction from "@js/components/actions/DisplayContentAction.vue";
import { computed, h } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const { row } = defineProps({
  row: {
    type: Object,
    required: true,
  },
});

const modulesContent = computed(() => {
  return h("ul", {}, [
    row.original.modules.map((module) => {
      return h(
        "li",
        {
          class: module.active ? "text-green-500" : "text-red-500",
        },
        module.fullTitle,
      );
    }),
  ]);
});

const externalServicesContent = computed(() => {
  return h("ul", {}, [
    row.original.externalServices.map((externalService) => {
      return h(
        "li",
        {
          class: externalService.active ? "text-green-500" : "text-red-500",
        },
        externalService.title,
      );
    }),
  ]);
});
</script>

<template>
  <div class="flex h-full flex-row items-center gap-2 p-4">
    <DisplayContentAction :title="t('title.modules')" :content="modulesContent">
      <template #button="{ setIsOpen }">
        <ActionButton
          size="small"
          class="size-8"
          :title="t('button.seeModules')"
          type="primary"
          :callback="() => setIsOpen(true)"
          :icon="CubeIcon"
        />
      </template>
    </DisplayContentAction>

    <DisplayContentAction
      :title="t('title.externalServices')"
      :content="externalServicesContent"
    >
      <template #button="{ setIsOpen }">
        <ActionButton
          size="small"
          class="size-8"
          :title="t('button.seeExternalServices')"
          type="primary"
          :callback="() => setIsOpen(true)"
          :icon="CogIcon"
        />
      </template>
    </DisplayContentAction>
  </div>
</template>
